import { FaNetworkWired } from 'react-icons/fa';
import React from 'react';
export function handleFilterFlexiaByType(flexias) {
  const typeDisplayMap = {
    DIALOG: 'Árvore de Diálogo',
    OPENAI: 'OpenAI',
    WATSON: 'Watson'
  };

  const typeOrder = ['DIALOG', 'OpenAI', 'Watson'];

  const types = [];
  const result = flexias
    .map((flexia) => {
      let isDivisor = false;
      let label = flexia.name;
      const displayType =
        typeDisplayMap[flexia?.type] || flexia?.type || 'Sem Tipo';

      if (!types.includes(flexia.type)) {
        types.push(flexia.type);
        isDivisor = true;
      }

      return {
        label: ` ${label}`,
        value: flexia.id,
        divisorCategory: isDivisor ? displayType : undefined,
        type: flexia.type,
        displayType: displayType,
        icon: <FaNetworkWired />
      };
    })
    .sort((a, b) => {
      const aIndex = typeOrder.indexOf(a.type);
      const bIndex = typeOrder.indexOf(b.type);
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      return a.type.localeCompare(b.type);
    });

  return result;
}
